import React from 'react'
import { hasChangedValues } from 'tyan/public/utility'
import { connect } from 'react-redux'

class MaterialSelect extends React.Component {
    state = {
    }

    componentDidMount = () => {
        this.GetMaterialList('')
    }

    GetMaterialList = (searchString = '') => {
        Tyan.doPostEvent({
            event: 'GetMaterialList',
            data: { search: searchString },
            onEnd: ({ errorMessage, initValues物料明细 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ initValues物料明细, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerConfirm = () => {
        const { id, onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'CreateRequisitionInfo',
            data: { id, changedValues基本信息 },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        const { changedValues基本信息: { ['物料明细-added']: added = [] } } = this.state
        return added.length > 0
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset物料明细 = () => {
        const { initValues物料明细 } = this.state
        return [
            {
                _checkgrid: '', name: '物料明细', rowNumbers: false, minRows: 15, margin: "5px 10px 5px 10px", minWidth: '90%',
                itemsValues: initValues物料明细, onSearch: this.GetMaterialList,
                columns: [
                    { _text: '物料代码', minWidth: 150, flex: 1 },
                    { _text: '物料名称', minWidth: 150, flex: 3 },
                    { _text: '单位', minWidth: 50, flex: 1 },
                    { _text: '规格型号', minWidth: 150, flex: 1 },
                    { _text: '资产大类', minWidth: 150, flex: 1 },
                ],
            },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { errorMessage, initValues物料明细 } = this.state
        if (errorMessage) Tyan.pubForm.showError(errorMessage)
        if (!initValues物料明细) return <Message text={'请稍等...'} />
        console.log('id', id)
        return <Body data={this} maxWidth="900"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !this.canSave() },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}

            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset物料明细() },
                ]
            }
        />
    }
}

export default connect()(MaterialSelect)